import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';

import store from '~store';

export interface GoogleRecaptchaModel {
  getResponse: typeof getResponse;
  validate: typeof validate;
  reset: typeof reset;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleRecaptcha',
  setup(__props, { expose }) {

const getters = store?.getters;

const captchaActive = getters.getCaptchaActive;
const e2eActive = !!Number(process.env.VUE_APP_IS_E2E_TEST);
const googleSiteKey = getters.getCaptchaSiteKey;
const hasError = ref(false);

onMounted(() => {
  if (captchaActive) {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
    script.setAttribute('data-cookiefirst-category', 'necessary');
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    document?.querySelector('head')?.append(script);
  }
});

function getResponse(): string | undefined {
  if (e2eActive) { // Only on e2e tests
    return parseInt(String(Math.random()).substring(2), 12).toString(36); // Random string
  }

  if (!captchaActive) { // For dev and WGS-VPN users, so no captcha is required
    return 'foo';
  }

  return (document?.querySelector?.('.g-recaptcha-response') as HTMLInputElement)?.value;
}

function validate(): boolean {
  if (captchaActive) {
    const response = getResponse();
    const valid = !!response?.length;

    hasError.value = !valid;
    return valid;
  }

  return true;
}

function reset(): void {
  window?.grecaptcha?.reset?.();
}

window.validateRecaptcha = validate;

expose({
  getResponse,
  validate,
  reset,
});


return { __sfc: true,getters, captchaActive, e2eActive, googleSiteKey, hasError, getResponse, validate, reset }
}

})